import * as n from "react";
import { useEffect as r, useState as t, useMemo as e, useRef as o, useCallback as i, useLayoutEffect as u } from "react";
import c from "lodash/debounce";
import a from "lodash/isUndefined";
import f from "lodash/isEqual";
var l = function (n, t) {
  var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
  r(function () {
    if (n && n.current && t && t.current) {
      var r = n.current.offsetTop,
        o = t.current,
        i = o.scrollTop;
      (r > o.offsetHeight || r < i) && t.current.scrollTo({
        top: r - e,
        behavior: "smooth"
      });
    }
  }, [t, n, e]);
};
function v(n, r) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(n);
    r && (e = e.filter(function (r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, e);
  }
  return t;
}
function d(n) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? v(Object(t), !0).forEach(function (r) {
      p(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : v(Object(t)).forEach(function (r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function s(n) {
  return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, s(n);
}
function p(n, r, t) {
  return (r = function (n) {
    var r = function (n, r) {
      if ("object" != typeof n || null === n) return n;
      var t = n[Symbol.toPrimitive];
      if (void 0 !== t) {
        var e = t.call(n, r || "default");
        if ("object" != typeof e) return e;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(n);
    }(n, "string");
    return "symbol" == typeof r ? r : String(r);
  }(r)) in n ? Object.defineProperty(n, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = t, n;
}
function y(n, r) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, r) {
    var t = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
    if (null != t) {
      var e,
        o,
        i,
        u,
        c = [],
        a = !0,
        f = !1;
      try {
        if (i = (t = t.call(n)).next, 0 === r) {
          if (Object(t) !== t) return;
          a = !1;
        } else for (; !(a = (e = i.call(t)).done) && (c.push(e.value), c.length !== r); a = !0);
      } catch (n) {
        f = !0, o = n;
      } finally {
        try {
          if (!a && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (f) throw o;
        }
      }
      return c;
    }
  }(n, r) || b(n, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function m(n) {
  return function (n) {
    if (Array.isArray(n)) return g(n);
  }(n) || function (n) {
    if ("undefined" != typeof Symbol && null != n[Symbol.iterator] || null != n["@@iterator"]) return Array.from(n);
  }(n) || b(n) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function b(n, r) {
  if (n) {
    if ("string" == typeof n) return g(n, r);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    return "Object" === t && n.constructor && (t = n.constructor.name), "Map" === t || "Set" === t ? Array.from(n) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? g(n, r) : void 0;
  }
}
function g(n, r) {
  (null == r || r > n.length) && (r = n.length);
  for (var t = 0, e = new Array(r); t < r; t++) e[t] = n[t];
  return e;
}
function h() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}
function w() {
  var n = y(t(null), 2),
    e = n[0],
    o = n[1];
  return r(function () {
    o(h());
    var n = c(function () {
      return o(h());
    }, 100);
    return window.addEventListener("resize", n), function () {
      return window.removeEventListener("resize", n);
    };
  }, []), e;
}
var O = function (n) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8,
    t = w();
  return e(function () {
    if (t && n && n.current) {
      var e = n.current.getBoundingClientRect(),
        o = e.top,
        i = e.bottom;
      return Math.max(t.height - i, o) - r;
    }
  }, [t, n, r]);
};
function j(n, t) {
  var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    i = e.options,
    u = e.enabled,
    c = void 0 === u || u,
    a = e.dependencies,
    f = void 0 === a ? [c, n] : a,
    l = e.element,
    v = o(function () {});
  r(function () {
    v.current = t;
  }, [t]), r(function () {
    if (!1 !== c) {
      if ("once" === c || !0 === c) {
        var r = function (n) {
            v.current(n);
          },
          t = d(d({}, i), {}, {
            once: "once" === c
          });
        return (null != l ? l : document).addEventListener(n, r, t), function () {
          (null != l ? l : document).removeEventListener(n, r, t);
        };
      }
      console.error("Received value of type ".concat(s(c), " for property `enabled`. Expected a boolean."));
    }
  }, f);
}
function S(n, r) {
  var t = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
  function e(n) {
    var t,
      e = n.target;
    return Array.isArray(r) ? r.some(function (n) {
      var r;
      return null === (r = n.current) || void 0 === r ? void 0 : r.contains(e);
    }) : (null === (t = r.current) || void 0 === t ? void 0 : t.contains(e)) || !1;
  }
  j("mousedown", function (n) {
    e(n) || (n.preventDefault(), n.stopPropagation());
  }, {
    enabled: t
  }), j("click", function (r) {
    e(r) || (r.stopPropagation(), n());
  }, {
    options: {
      capture: !0
    },
    enabled: t
  });
}
var P = function (n, e) {
    var o = !a(n),
      i = y(t(null != n ? n : ""), 2),
      u = i[0],
      c = i[1];
    r(function () {
      a(n) || c(n);
    }, [n]);
    return {
      isControlled: o,
      value: u,
      handleChange: function (n) {
        null == e || e(n), o || c(n.target.value);
      },
      setInternalValue: c
    };
  },
  A = new Map();
function E(r) {
  return function () {
    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return function (t) {
      if (t) {
        var e = r + "-" + t;
        if (A.get(e)) return A.get(e);
        var o = n.createRef();
        return A.set(e, o), o;
      }
      console.error("useDynamicRefs: Cannot get ref without key");
    };
  }(r.prefix);
}
var x = function (n, r) {
  return j("keydown", function (r) {
    return function (n, r) {
      27 === n.keyCode && (n.stopImmediatePropagation(), r());
    }(r, n);
  }, r);
};
function C() {
  var n = y(t({}), 2)[1];
  return i(function () {
    return n({});
  }, []);
}
function I(n) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    t = r.initialValue,
    i = r.deps,
    u = void 0 === i ? [] : i,
    c = o(t);
  return e(function () {
    return {
      get current() {
        return c.current;
      },
      set current(r) {
        c.current = r, n(r);
      }
    };
  }, [n, c].concat(m(u)));
}
function T(n, r) {
  var t = i(function (n, r) {
    Array.isArray(n) ? n.forEach(t) : "function" == typeof n ? n(r) : n && (n.current = r);
  }, []);
  return I(i(function (r) {
    return t(n, r);
  }, [n, t]), {
    initialValue: r
  });
}
var D = 0;
function k(n) {
  var e = n.prefix;
  return function (n) {
    var e = n.id,
      o = n.prefix,
      i = y(t(e), 2),
      u = i[0],
      c = i[1];
    return r(function () {
      null == u && c(D += 1);
    }, [u, o]), e || "".concat(null != o ? o : "lg", "-").concat(u);
  }({
    id: n.id,
    prefix: e
  });
}
var L = function () {
  return ("undefined" == typeof window ? r : u).apply(void 0, arguments);
};
function M(n, e, o) {
  var i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
    u = y(t(), 2),
    c = u[0],
    a = u[1];
  return r(function () {
    if (i) {
      var r = new MutationObserver(function () {
        a(o.apply(void 0, arguments));
      });
      return n && r.observe(n, e), function () {
        return r.disconnect();
      };
    }
  }, [n, e, o, i]), c;
}
function R(n) {
  var r = o();
  return void 0 !== r.current && f(r.current, n) || (r.current = n), r.current;
}
function B(n) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    i = e.interval,
    u = void 0 === i ? 3e4 : i,
    c = e.immediate,
    a = void 0 === c || c,
    f = e.enabled,
    l = void 0 === f || f,
    v = o(),
    d = function () {
      var n = function () {
          return "visible" === document.visibilityState;
        },
        e = y(t(!0), 2),
        o = e[0],
        i = e[1];
      return r(function () {
        i(n);
      }, []), j("visibilitychange", function () {
        i(n);
      }), o;
    }() && l;
  r(function () {
    v.current = n;
  }), r(function () {
    var n;
    if (d) return a ? e() : r(), t;
    function r() {
      t(), n = setTimeout(e, u);
    }
    function t() {
      clearTimeout(n);
    }
    function e() {
      var n;
      Promise.resolve(null === (n = v.current) || void 0 === n ? void 0 : n.call(v)).finally(r);
    }
  }, [u, a, d]);
}
function V(n) {
  var t = o();
  return r(function () {
    t.current = n;
  }), t.current;
}
function z(n) {
  var r = y(t(n), 2),
    e = r[0],
    i = r[1],
    u = o(e);
  return [e, function (n) {
    i(n), u.current = n;
  }, function () {
    return u.current;
  }];
}
function H(n) {
  var r = y(t(!1), 2),
    e = r[0],
    o = r[1];
  if (a(n) || "function" != typeof n) return {
    onBlur: function () {},
    onChange: function () {}
  };
  return {
    onBlur: function (r) {
      o(!0), null == n || n(r.target.value);
    },
    onChange: function (r) {
      e && (null == n || n(r.target.value));
    }
  };
}
export { l as useAutoScroll, O as useAvailableSpace, S as useBackdropClick, P as useControlledValue, E as useDynamicRefs, x as useEscapeKey, j as useEventListener, C as useForceRerender, T as useForwardedRef, k as useIdAllocator, L as useIsomorphicLayoutEffect, M as useMutationObserver, R as useObjectDependency, I as useObservedRef, B as usePoller, V as usePrevious, z as useStateRef, H as useValidation, w as useViewportSize };